import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Typography } from '@material-ui/core';
import IconExpandMore from '@material-ui/icons/ExpandMore';

import { useStyles } from './useStyles';

export const WorkspaceButton = ({ className, workspaceName, open, onClick }) => {
  const styles = useStyles();

  return (
    <Button
      className={cx(className, styles.root, open && styles.expanded)}
      variant="text"
      onClick={onClick}
      data-testid="WorkspaceButton"
      data-onboarding="WorkspaceButton"
      disableFocusRipple
    >
      <div className={styles.names}>
        <Typography
          className={styles.productWorkspace}
          variant="body1"
        >
          Workspace
        </Typography>
        <div className={styles.workspaceGroup}>
          {workspaceName && <div className={styles.firstLetter}>{workspaceName.charAt(0)}</div>}
          <Typography
            className={styles.workspaceName}
            variant="body1"
          >
            {workspaceName || 'No workspaces'}
          </Typography>
        </div>
      </div>

      <IconExpandMore className={cx(styles.iconExpand, open && styles.expanded)} />
    </Button>
  );
};

WorkspaceButton.propTypes = {
  className: PropTypes.string,
  workspaceName: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

WorkspaceButton.defaultProps = {
  className: null,
  open: false,
};
